import { DateTimeUtcService, useAppNowUtc, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { isAnyClientEnterpriseIntegrationsEnabled } from '@mews-commander/legacy-entities/src/ducks/enterpriseIntegrations';
import { Reservation, ReservationTimeState } from '@mews-commander/data-access';
import { UPSELL_HOUR_AVAILABILITY } from '../../constants';
import { getOakyUpsellingClientId } from './selectors';
import Upsell from './Upsell';

interface Props {
    reservationId: string;
    startUtc: string;
    reservationTimeState: Reservation['reservationTimeState'];
}

const ReservationTimeStates = [
    ReservationTimeState.ToBeCheckedIn,
    ReservationTimeState.CheckedIn,
    ReservationTimeState.ToBeCheckedOut,
];
export const UpsellContainer = ({ reservationId, startUtc, reservationTimeState }: Props) => {
    const isUpsellingEnabled = useFeatureFlag(FeatureFlag.upsellEnabled);
    const enterpriseId = useCurrentEnterpriseId();
    const clientId = useCommanderSelector(getOakyUpsellingClientId);
    const isUpsellingIntegrationEnabled = useCommanderSelector((state) =>
        isAnyClientEnterpriseIntegrationsEnabled(state, { enterpriseId, clientId })
    );

    const nowDateTimeUtc = useAppNowUtc();
    const upsellableWindow = DateTimeUtcService.diffHours(DateTimeUtcService.parse(startUtc), nowDateTimeUtc);
    const startsInUpsellableWindow = upsellableWindow <= UPSELL_HOUR_AVAILABILITY && upsellableWindow > 0;

    const isUpsellable = startsInUpsellableWindow || ReservationTimeStates.includes(reservationTimeState);
    if (!isUpsellingEnabled || !isUpsellingIntegrationEnabled || !isUpsellable) return null;

    return <Upsell reservationId={reservationId} />;
};
